import { HttpClient } from '@angular/common/http';
import { APIBaseManager } from '../../api.base';
import { IVirtualDeviceRxData } from './virtualDevice.common';

export interface IRemoveVirtualDevicePathParameter {
    virtualDeviceID: string;
}

export class APIRemoveVirtualDeviceManager extends APIBaseManager<IRemoveVirtualDevicePathParameter, void, void, IVirtualDeviceRxData> {
    constructor(protected http: HttpClient) {
        super(http);
        this._apiName = 'API_RemoveVirtualDevice';
        this._apiMethod = 'DELETE';
    }

    protected getRequestURL(pathParameters: IRemoveVirtualDevicePathParameter, queryParameters: void): string {
        return super.getRequestURL() + 'virtualDevices/' + pathParameters.virtualDeviceID;
    }
}